export default "__VITE_ASSET__fce32dc2__"